'use strict';

import angular from 'angular';
import template from './modal.pug';

const NewCardModalSvc = [
  'ModalSvc',
  'LoaderSvc',
  '$rootScope',
  '$location',
  'StripeSvc',
  function(ModalSvc, LoaderSvc, $rootScope, $location, StripeSvc) {
    function extractErrorMessage(err, fallback) {
      return err && err.data && err.data.message
        || err && err.data && err.data.error && err.data.error.message
        || err && err.message
        || err && err.raw && err.raw.message
        || fallback
        || 'An error occurred';
    }

    function open() {
      var modalInstance;
      var modalvm = {
        isCardInputInvalid: true
      };

      function setCardError(message) {
        // eslint-disable-next-line no-undef
        var cardErrorsElement = document.getElementById('card-errors');
        if(cardErrorsElement) {
          cardErrorsElement.textContent = message || '';
        }
      }

      function setCardInputInvalid(isInvalid) {
        $rootScope.$applyAsync(function() {
          modalvm.isCardInputInvalid = !!isInvalid;
          if(modalScope && modalScope.modalvm && modalScope.modalvm.buttons) {
            modalScope.modalvm.buttons[0].disabled = modalvm.isCardInputInvalid;
          }
        });
      }

      function cardInputIsInvalid(event) {
        return !event || event.error || event.complete === false;
      }

      function clearCardError() {
        setCardError('');
        setCardInputInvalid(false);
      }

      //////////////////////////////////////////////////////////////////////////
      // Testing Data
      //////////////////////////////////////////////////////////////////////////
      var url = $location.absUrl();
      if(url.toLowerCase().includes('sandbox')
        || url.toLowerCase().includes('staging')
        || url.toLowerCase().includes('localhost')) {
        var futureYear = new Date().getFullYear() + 1;

        /* eslint-disable camelcase, max-len */
        var baseCard = {exp_month: 1, exp_year: futureYear,
          cvc: '123', address_zip: '94301'};

        /**
         * https://stripe.com/docs/testing#cards
         */
        var testCards = [
          // good cards
          {number: '4242424242424242', name: 'Success - Visa', display: 'success'},
          {number: '4012888888881881', name: 'Success - Visa', display: 'success'},
          {number: '4000056655665556', name: 'Success - Visa (debit)', display: 'success'},
          {number: '5555555555554444', name: 'Success - Mastercard', display: 'success'},
          {number: '5200828282828210', name: 'Success - Mastercard (debit)', display: 'success'},
          {number: '5105105105105100', name: 'Success - Mastercard (prepaid)', display: 'success'},
          {number: '378282246310005', name: 'Success - American Express', display: 'success'},
          {number: '371449635398431', name: 'Success - American Express', display: 'success'},
          {number: '6011111111111117', name: 'Success - Discover', display: 'success'},
          {number: '6011000990139424', name: 'Success - Discover', display: 'success'},
          {number: '30569309025904', name: 'Success - Diners Club', display: 'success'},
          {number: '38520000023237', name: 'Success - Diners Club', display: 'success'},
          {number: '3530111333300000', name: 'Success - JCB', display: 'success'},
          {number: '3566002020360505', name: 'Success - JCB', display: 'success'},

          // bad cards
          // {number: '4000000000000077', name: '', display: 'error'}, // Charge succeeds and funds will be added directly to your available balance (bypassing your pending balance).
          // {number: '4000000000000093', name: '', display: 'error'}, // Charge succeeds and domestic pricing is used (other test cards use international pricing). This card is only significant in countries with split pricing.
          // {number: '4000000000000010', name: '', display: 'error'}, // The address_line1_check and address_zip_check verifications fail. If your account is blocking payments that fail ZIP code validation, the charge is declined.
          // {number: '4000000000000028', name: '', display: 'error'}, // Charge succeeds but the address_line1_check verification fails.
          // {number: '4000000000000036', name: '', display: 'error'}, // The address_zip_check verification fails. If your account is blocking payments that fail ZIP code validation, the charge is declined.
          // {number: '4000000000000044', name: '', display: 'error'}, // Charge succeeds but the address_zip_check and address_line1_check verifications are both unavailable.
          // {number: '4000000000000101', name: '', display: 'error'}, // If a CVC number is provided, the cvc_check fails. If your account is blocking payments that fail CVC code validation, the charge is declined.
          // {number: '4000000000000341', name: '', display: 'error'}, // Attaching this card to a Customer object succeeds, but attempts to charge the customer fail.
          // {number: '4000000000009235', name: '', display: 'error'}, // Charge succeeds with a risk_level of elevated and placed into review.
          {number: '4000000000000002', name: 'Error - Declined', display: 'error'}, // Charge is declined with a card_declined code.
          {number: '4100000000000019', name: 'Error - Processing Error', display: 'error'}, // Charge is declined with a card_declined code and a fraudulent reason.
          // {number: '4000000000000127', name: '', display: 'error'}, // Charge is declined with an incorrect_cvc code.
          // {number: '4000000000000069', name: '', display: 'error'}, // Charge is declined with an expired_card code.
          // {number: '4000000000000119', name: '', display: 'error'}, // Charge is declined with a processing_error code.
          {number: '4242424242424241', name: 'Error - Incorrect Card Number', display: 'error'}, // Charge is declined with an incorrect_number code as the card number fails the Luhn check.
          {number: '4242424242424242', exp_month: 13, name: 'Error - Invalid Month', display: 'error'}, // invalid_expiry_month: Use an invalid month (e.g. 13)
          {number: '4242424242424242', exp_year: '197', name: 'Error - Invalid Year', display: 'error'}, // invalid_expiry_year: Use a year in the past (e.g. 1970)
          {number: '4242424242424242', exp_year: '1970', name: 'Error - Expired Card', display: 'error'}, // invalid_expiry_year: Use a year in the past (e.g. 1970)
          {number: '4242424242424242', cvc: '99', name: 'Error CVC', display: 'error'}, // invalid_cvc: Use a two digit number (e.g. 99)

          // 3D Secure Test Cards
          {number: '4000000000003220', name: '3DS Required - Complete Auth', display: 'success'},
          {number: '4000008400001629', name: '3DS Required - Decline Auth', display: 'error'}
        ];

        testCards = testCards.map(function(c) {
          return angular.extend({}, baseCard, c);
        });
        testCards.push({name: 'Reset'});
        modalvm.testCards = testCards;

        modalvm.populateCard = function(c) {
          if(c.name === 'Reset') {
            // Clear any non-sensitive fields you control
            modalvm.formvm = {};
          } else {
            // Copy card number to clipboard for user to paste into Stripe Element
            // eslint-disable-next-line no-lonely-if, no-undef
            if(c.number && navigator && navigator.clipboard) {
              // eslint-disable-next-line no-undef
              navigator.clipboard.writeText(c.number);
              LoaderSvc.stopSuccess('Card number copied! Paste it into the card field.');
            }
          }
        };
      }

      // Stripe.js v3 integration
      let cardElement;

      // Open modal first, then mount Stripe Element after modal is rendered
      var modalScope = {modalvm: angular.extend(modalvm, {
        title: 'New Card',
        dismissable: true,
        buttons: [
          {classes: 'btn-primary', text: 'Add Card', click: onSubmit, disabled: modalvm.isCardInputInvalid},
          {classes: 'btn-default', text: 'Cancel', click: onCancel}
        ]
      })};
      var options = {template};
      modalInstance = ModalSvc.open(modalScope, options);

      // Mount Stripe Element after modal is rendered and Stripe is initialized
      // eslint-disable-next-line no-undef
      setTimeout(() => {
        if(!StripeSvc.createCardPaymentMethod) {
          LoaderSvc.stopError('Stripe service not ready');
          return;
        }
        // Wait for StripeSvc to initialize Stripe and provide the instance
        // Use StripeSvc to get the stripeInstance and elements
        // We'll assume StripeSvc exposes a method to get the instance
        // and that it has already initialized with the correct key
        // eslint-disable-next-line no-undef
        if(!window.Stripe) {
          LoaderSvc.stopError('Stripe.js not loaded');
          return;
        }
        // Use Stripe.js v3 Elements
        const stripe = StripeSvc.getStripeInstance();
        if(!stripe) {
          LoaderSvc.stopError('Stripe not initialized');
          return;
        }
        const elements = stripe.elements();
        cardElement = elements.create('card');
        cardElement.mount('#card-element');
        cardElement.on('change', function(event) {
          if(cardInputIsInvalid(event)) {
            setCardInputInvalid(true);
            if(event && event.error && event.error.message) {
              setCardError(event.error.message);
            } else {
              setCardError('Complete the card details before adding the card.');
            }
            return;
          }

          clearCardError();
        });
      }, 0);

      async function onSubmit() {
        if(modalvm.isCardInputInvalid) {
          LoaderSvc.stopError('Complete the card details before adding the card.');
          return;
        }

        LoaderSvc.start();
        try {
          // Use StripeSvc to create the payment method
          const result = await StripeSvc.createCardPaymentMethod(cardElement, {});
          if(result.error) {
            let errorMessage = extractErrorMessage(
              result.error,
              result.error.message
            );
            if(result.error.type === 'validation_error') {
              setCardInputInvalid(true);
              if(errorMessage === result.error.message) {
                errorMessage = 'Complete the card details before adding the card.';
              }
            }
            setCardError(errorMessage);
            LoaderSvc.stopError(errorMessage);
          } else {
            // Attach the payment method to the user/customer
            try {
              await StripeSvc.attachPaymentMethodToUser(result.paymentMethod.id);
              clearCardError();
              LoaderSvc.stopSuccess('Card Created');
              modalInstance.close({paymentMethodId: result.paymentMethod.id});
            } catch(attachErr) {
              var attachErrorMessage = extractErrorMessage(
                attachErr,
                'Error adding card'
              );
              setCardError(attachErrorMessage);
              if(attachErr && attachErr.type === 'validation_error') {
                setCardInputInvalid(true);
              }
              LoaderSvc.stopError(attachErrorMessage);
            }
          }
        } catch(err) {
          let caughtErrorMessage = extractErrorMessage(err, 'Error adding card');
          if(err && err.type === 'validation_error') {
            setCardInputInvalid(true);
            caughtErrorMessage = caughtErrorMessage === err.message
              ? 'Complete the card details before adding the card.'
              : 'Card input needs attention: ' + caughtErrorMessage;
          }
          setCardError(caughtErrorMessage);
          LoaderSvc.stopError(caughtErrorMessage);
        }
      }

      function onCancel() {
        modalInstance.dismiss();
      }

      return modalInstance.result;
    }

    // Public API here
    return {
      open
    };
  }
];

export default NewCardModalSvc;

